var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCountertops = function SvgCountertops(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.667 33.334v-13.89H3.333v-2.777h6.39q-1.261 0-2.159-.898a2.94 2.94 0 0 1-.897-2.158V6.667h9.722v6.945q0 1.26-.898 2.157a2.94 2.94 0 0 1-2.158.898h14.445v-5.278q0-.825-.558-1.385t-1.382-.56q-.825 0-1.387.577-.563.576-.534 1.368H21.11q.028-1.972 1.4-3.347 1.373-1.375 3.334-1.375 1.96 0 3.335 1.377 1.375 1.379 1.375 3.345v5.278h6.112v2.778h-3.334v13.889zm2.777-19.445h4.167V9.445H9.444zm0 16.667h9.167V19.445H9.444zm11.945 0h9.167V19.445h-9.167z"
  })));
};
export default SvgCountertops;